export const applyDrag = (arr, dragResult, handleRearrangePriorty) => {
  const { removedIndex, addedIndex, payload } = dragResult;
  handleRearrangePriorty(removedIndex, addedIndex);
  if (removedIndex === null && addedIndex === null) {
    return arr;
  }

  const result = [...arr];
  let itemToAdd = payload;

  if (removedIndex !== null) {
    itemToAdd = result.splice(removedIndex, 1)[0];
  }

  if (addedIndex !== null) {
    result.splice(addedIndex, 0, itemToAdd);
  }

  return result;
};
